import React from 'react'
import './aboutMe.css'

const AboutMe = () => {
  return (
      <section className='about'>
          <p className='about__text'>
              I'm a self-taught front-end programmer, started to learn programming as a hobby and then decided to take it more
              serious and started to do <a href='https://www.theodinproject.com/' target='_blank' rel='noreferrer'>The Odin Project</a>,
              now i look to learn even more with the professionals.
          </p>
      </section>
  )
}

export default AboutMe